import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class Currency extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/currency/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });
        Promise.all([p1]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.numericCode)) this.state.data.record.numericCode = 0;

        this.httpPost("api/v1/currency/save", {
            id: this.state.id,
            currencyName: this.state.data.record.currencyName,
            alphabeticCode: this.state.data.record.alphabeticCode,
            numericCode: this.state.data.record.numericCode,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات ارز" : "افزودن ارز جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان:</label>
                                            <input defaultValue={this.state.data.record.currencyName} onChange={e => this.state.data.record.currencyName = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">کدحرفی:</label>
                                            <input defaultValue={this.state.data.record.alphabeticCode} onChange={e => this.state.data.record.alphabeticCode = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">کدعددی:</label>
                                            <input defaultValue={this.state.data.record.numericCode} onChange={e => this.state.data.record.numericCode = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}